import type { ReactNode } from "react";
import styles from "./Notices.module.css";

// A URL up to whitespace, minus trailing punctuation that belongs to the
// sentence rather than the link („viz https://cmf.cz.").
const URL_RE = /https?:\/\/[^\s<>]*[^\s<>.,;:!?)\]'"„“]/g;

function linkify(line: string): ReactNode[] {
  const out: ReactNode[] = [];
  let last = 0;
  for (const m of line.matchAll(URL_RE)) {
    const at = m.index ?? 0;
    if (at > last) out.push(line.slice(last, at));
    out.push(
      <a key={at} href={m[0]} target="_blank" rel="noopener noreferrer">
        {m[0]}
      </a>,
    );
    last = at + m[0].length;
  }
  if (last < line.length) out.push(line.slice(last));
  return out;
}

/**
 * The body of an oznámení. Plain text by design: a blank line starts a
 * paragraph, a newline breaks the line, and a web address becomes a link.
 * Nothing else is interpreted, so a notice can never carry markup.
 */
export function NoticeText({ text }: { text: string }) {
  const paragraphs = text.split(/\n{2,}/).filter((p) => p.trim() !== "");
  if (paragraphs.length === 0) return null;
  return (
    <div className={styles.text}>
      {paragraphs.map((p, i) => (
        <p key={i}>
          {p.split("\n").map((line, j) => (
            <span key={j}>
              {j > 0 && <br />}
              {linkify(line)}
            </span>
          ))}
        </p>
      ))}
    </div>
  );
}
